import { GetPickupPointByGeoCoordQueryArgs } from '@savgroup-front-common/core/api/Carrier/getPickupPointByGeoCoordQuery/getPickupPointByGeoCoordQuery';
import { Carrier } from '@/api/Claim/getClaimGroupCarrierQuery';

export const preparePickupPoints = ({
  carriers,
  countryCode,
  distance,
  maxPickupPoint,
  sellerId,
  address,
  claimId,
  weight,
}: {
  carriers: Carrier[];
  countryCode: string;
  distance: number;
  maxPickupPoint: number;
  sellerId?: string;
  address: string;
  claimId?: string;
  weight?: number;
}) => {
  return (
    (carriers?.map((carrier) => ({
      countryCode,
      carrierCompany: carrier.carrierBrand,
      distance,
      maxPickupPoint,
      productType: carrier.productType,
      carrierProductId: carrier.carrierProductId,
      carrierName: carrier.carrierName,
      sellerId,
      address,
      claimId,
      weight,
    })) as GetPickupPointByGeoCoordQueryArgs[]) || []
  );
};
